// import { colors } from '@mui/material'
// import { blue } from '../customColors'

// import { type ButtonBaseProps } from '@mui/material'
// import { palette } from '../palette'

export default function Button (theme: any) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderRadius: 35,
          padding: '8px 18px',
          fontSize: '14px'
        },
        sizeLarge: {
          height: 48
        },
        containedInherit: {
          // color: theme.palette.grey[800],
          // boxShadow: theme.customShadows.z8,
          // '&:hover': {
          //   backgroundColor: theme.palette.grey[400]
          // }
        },
        containedPrimary: {
          // backgroundColor: blue[500],
          // border: 'none',
          // color: colors.common.white
        },
        containedSecondary: {
          // boxShadow: theme.customShadows.secondary
        },
        outlinedInherit: {
          // border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
          // '&:hover': {
          //   backgroundColor: theme.palette.action.hover
          // }
        },
        outlinedPrimary: {
          backgroundColor: theme.palette.background.paper,
          border: '2px solid',
          borderColor: theme.palette.grey[97],
          boxShadow: '0px 2px 5px 0px rgba(38, 51, 77, 0.03)',
          color: theme.palette.grey[60],
          '&:hover': {
            backgroundColor: theme.palette.background.paper,
            border: '2px solid',
            borderColor: theme.palette.grey[97]
          }
        },
        outlinedSecondary: {
          backgroundColor: theme.palette.background.paper,
          border: '2px solid',
          borderColor: theme.palette.grey[97],
          boxShadow: '0px 2px 5px 0px rgba(38, 51, 77, 0.03)',
          color: theme.palette.secondary.main,
          '&:hover': {
            color: theme.palette.secondary.dark,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid',
            borderColor: theme.palette.grey[97]
          }
        }
        // textInherit: {
        //   '&:hover': {
        //     backgroundColor: theme.palette.action.hover
        //   }
        // }
      }
    }
  }
}

// export const Button: Partial<Components> = {
//   MuiButton: {
//     styleOverrides: {
//       root: {
//         '&:hover': {
//           boxShadow: 'none'
//         },
//         textTransform: 'none',
//         borderRadius: '20px',
//         lineHeight: 1,
//         fontSize: 12,
//         fontWeight: 700,
//         letterSpacing: 0.01
//       },
//       sizeLarge: {
//         height: 48
//       },
//       containedInherit: {
//         // color: theme.palette.grey[800],
//         // boxShadow: theme.customShadows.z8,
//         '&:hover': {
//           // backgroundColor: theme.palette.grey[400]
//         }
//       },
//       containedPrimary: {
//         borderRadius: 35,
//         backgroundColor: colors.common.white,
//         border: 'none',
//         boxShadow: '0px 2px 5px 0px rgba(38, 51, 77, 0.03)',
//         padding: '12px 18px',
//         color: blue[500],
//         fontSize: '12px'
//         // boxShadow: theme.customShadows.primary
//       },
//       containedSecondary: {
//         color: '#09B5EC',
//         borderRadius: 35,
//         backgroundColor: '#FFF',
//         border: '2px solid #FFF',
//         padding: '12px 18px',
//         fontSize: '12px'
//         // boxShadow: theme.customShadows.secondary
//       },
//       outlinedInherit: {
//         // border: `1px solid ${alpha(theme.palette.grey[500], 0.32)}`,
//         '&:hover': {
//           // backgroundColor: theme.palette.action.hover
//         }
//       },
//       outlinedPrimary: {
//         borderRadius: 35,
//         border: '2px solid #F7F8FA',
//         color: palette.grey[60],
//         padding: '12px 18px',
//         fontSize: '12px'
//       },
//       outlinedSecondary: {
//         color: '#09B5EC',
//         borderRadius: 35,
//         backgroundColor: '#FFF',
//         border: '2px solid #FFF',
//         padding: '12px 18px',
//         fontSize: '12px'
//       },
//       textInherit: {
//         '&:hover': {
//           // backgroundColor: theme.palette.action.hover
//         }
//       }
//     }
//   }
// }
